module.exports = __webpack_public_path__ + "static/img/13.da3b9b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/eng/13.png
// module id = Tp3c
// module chunks = 0